import Vue from 'vue'
import VueI18n from 'vue-i18n'
import es from './locales/es'
import en from './locales/en'
import fr from './locales/fr'
import ar from './locales/ar'
import zh from './locales/zh'

Vue.use(VueI18n)

const savedLocale = localStorage.getItem('app_lang') || 'es'

const i18n = new VueI18n({
    locale: savedLocale,
    fallbackLocale: 'es',
    silentTranslationWarn: true,
    messages: {
        es,
        en,
        ar,
        fr,
        zh
    }
})

export default i18n